module.exports = __webpack_public_path__ + "static/media/arrow.865c7041.svg";